import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import {
  GoogleCalendarCalendarEventEntity,
  GoogleCalendarEventsListInput,
} from "@cohesive/api-entities";
import { useInfiniteQuery } from "@tanstack/react-query";

export function useGoogleCalendarEventsList(
  connection: IntegrationConnection | null | undefined,
  input: GoogleCalendarEventsListInput,
) {
  return useInfiniteQuery({
    queryKey: ["google-calendar-events-list", connection?.id, input],
    queryFn: ({ pageParam = {} }) => {
      return orgAPI.toolbox.execute<GoogleCalendarCalendarEventEntity[]>({
        integration_connection_id: connection!.id,
        action_name: "google-calendar-events-list",
        action_input: {
          ...input,
          ...pageParam,
        },
        // Typed events drive the rich row UI; their generic projections ride
        // along in data_generic and are what get placed on the canvas.
        entity_format: "both",
      });
    },
    getNextPageParam: (lastPage) => {
      return lastPage.pagination?.next;
    },
    initialPageParam: {},
    enabled: !!connection && !!input.calendar_id, // Only run when connection exists and calendar is selected
  });
}
